import React from 'react';
import { RhNumberField } from '../../../../../../../../dum';
import {
    KILO_PRICE,
    ORDER_QUOTATION_PRODUCTS,
} from '../order-quotation-products-columns';
import { useCalculateProductsTotal } from '../../../helpers/use-calculate-products-total';
import { FIELD_LABELS, shortLabel } from '../../../../../../../../../helpers';

export function KiloPriceInput({ index }: { index: number }) {
    // Free-priced by design: unlike the pedido form, the price is EDITABLE and
    // there is no catalog check. Acceptance is what writes the catalog later.
    const INPUT_NAME = `${ORDER_QUOTATION_PRODUCTS}.${index}.${KILO_PRICE}`;
    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhNumberField
            name={INPUT_NAME}
            label={shortLabel(FIELD_LABELS.kilo_price)}
            disableGutters
            onChange={() => {
                calculateProductsTotal();
            }}
        />
    );
}
